import dropdowncss from "../css/dropdown.module.css";
import commoncss from "../css/common.module.css";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down_arrow.svg";
import { ReactComponent as UpArrowIcon } from "../assets/icons/up_arrow.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";

// export default function Dropdown({
//   req=false,
//   class_="",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);

//   // Automatically select the option if there's only one
//   useEffect(() => {
//     if (options.length === 1) {
//       const singleOption = options[0];
//       setSelectedOptionLabel(singleOption.label);
//       onSelect && onSelect({ label: singleOption.label, value: singleOption.value });
//     } else if (selected && selected.label) {
//       setSelectedOptionLabel(selected.label);
//     }
//   }, [options, selected, onSelect]);

//   const handleSelect = (option) => {
//     onSelect && onSelect({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     // <div className={`${dropdowncss.dropdown_wrapper} ${commoncss.w60pct}`}>
//       <div className={`${dropdowncss.dropdown_wrapper} ${class_}`}>
//       {label && <span className={dropdowncss.dropdown_label}> {req&&(<ReqFieldLabel/>)}&nbsp; {label}</span>}
//       <div className={`${dropdowncss.dropdown} ${class_}`} onClick={() => setOpen(!open)}>
//         <div
//           className={`${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//         >
//           {selectedOptionLabel || placeHolder}
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>
//         <div
//           className={`${dropdowncss.dropdown_menu} ${open ? dropdowncss.open : ""}`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function Dropdown({
//   req = false,
//   class_ = "",
//   class2_ = "",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
//   selValue = null, // New prop
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   useEffect(() => {
//     let labelToSet = null;

//     if (options.length === 1) {
//       labelToSet = options[0].label;
//       if (selectedOptionLabel !== labelToSet) {
//         setSelectedOptionLabel(labelToSet);
//         onSelect &&
//           onSelect({ label: options[0].label, value: options[0].value });
//       }
//     } else if (selValue) {
//       const matchedOption = options.find(
//         (opt) =>
//           String(opt.value).toLowerCase() === String(selValue).toLowerCase()
//       );
//       if (matchedOption && selectedOptionLabel !== matchedOption.label) {
//         setSelectedOptionLabel(matchedOption.label);
//         onSelect &&
//           onSelect({ label: matchedOption.label, value: matchedOption.value });
//       }
//     } else if (
//       selected &&
//       selected.label &&
//       selected.label !== selectedOptionLabel
//     ) {
//       setSelectedOptionLabel(selected.label);
//     }
//   }, [options, selected, selValue, onSelect, selectedOptionLabel]);

//   const handleSelect = (option) => {
//     onSelect && onSelect({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     <div
//       ref={dropdownRef}
//       className={`${dropdowncss.dropdown_wrapper} ${class_}`}
//     >
//       {label && (
//         <span className={dropdowncss.dropdown_label}>
//           {req && <ReqFieldLabel />} &nbsp; {label}
//         </span>
//       )}
//       <div
//         className={`${dropdowncss.dropdown} ${class_}`}
//         onClick={() => setOpen(!open)}
//       >
//         {/* <div
//           className={`${class2_} ${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//         >
//           {selectedOptionLabel || placeHolder}
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div> */}
//         <div
//           className={`${class2_} ${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//           data-tooltip={selectedOptionLabel || ""}
//         >
//           <span className={dropdowncss.dropdown_selected_text}>
//             {selectedOptionLabel || placeHolder}
//           </span>
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>

//         <div
//           className={`${dropdowncss.dropdown_menu} ${
//             open ? dropdowncss.open : ""
//           }`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

export default function FSfilterDropdown({
  req = false,
  class_ = "",
  class2_ = "",
  label,
  options = [],
  onSelect,
  placeHolder,
  selected = {},
  selValue = null,
}) {
  const [open, setOpen] = useState(false);
  const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  // ================= CLEAR SEARCH ON CLOSE =================
  useEffect(() => {
    if (!open) {
      setSearchQuery("");
    }
  }, [open]);

  const filteredOptions = options.filter((opt) =>
    String(opt.label || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  // ================= CLICK OUTSIDE =================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ================= SYNC SELECTION =================
  useEffect(() => {
    let matchedOption = null;

    // Auto-select if only one option
    if (options.length === 1) {
      matchedOption = options[0];
    }

    // Match by selValue
    else if (selValue != null) {
      matchedOption = options.find(
        (opt) =>
          String(opt.value).toLowerCase() === String(selValue).toLowerCase()
      );
    }

    // Match by selected.label
    else if (selected?.label) {
      matchedOption = options.find((opt) => opt.label === selected.label);
    }

    // ✅ FOUND → SET
    if (matchedOption) {
      if (selectedOptionLabel !== matchedOption.label) {
        setSelectedOptionLabel(matchedOption.label);
        onSelect?.({
          label: matchedOption.label,
          value: matchedOption.value,
        });
      }
    }

    // ❌ NOT FOUND → RESET
    else if (selectedOptionLabel !== null) {
      setSelectedOptionLabel(null);
      onSelect?.(null); // reset parent
    }
  }, [options, selected, selValue]);

  // ================= MANUAL SELECT =================
  const handleSelect = (option) => {
    onSelect?.({ label: option.label, value: option.value });
    setSelectedOptionLabel(option.label);
    setOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${dropdowncss.dropdown_wrapper} ${class_}`}
    >
      {label && (
        <span className={dropdowncss.dropdown_label}>
          {req && <ReqFieldLabel />} &nbsp; {label}
        </span>
      )}

      <div
        className={`${dropdowncss.dropdown} ${class_}`}
        onClick={() => setOpen(!open)}
      >
        {/* <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          data-tooltip={selectedOptionLabel || ""}
        > */}
        <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          {...(selectedOptionLabel && selectedOptionLabel.trim() !== ""
            ? { "data-tooltip": selectedOptionLabel }
            : {})}
          style={{ padding: "0 13px", height: "35px", display: "flex", alignItems: "center" }}
        >
          <input
            type="text"
            placeholder={placeHolder}
            value={open ? searchQuery : (selectedOptionLabel || "")}
            onChange={(e) => {
              if (!open) setOpen(true);
              setSearchQuery(e.target.value);
            }}
            onFocus={() => {
              setOpen(true);
              setSearchQuery(selectedOptionLabel || "");
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              fontSize: "13px",
              color: (open ? searchQuery : selectedOptionLabel) ? "#205a46" : "#b3c0bd",
              width: "100%",
              height: "100%",
              padding: 0,
              fontFamily: "inherit",
              fontWeight: 400,
            }}
          />
          <span
            className={dropdowncss.dropdown_arrow}
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {open ? <UpArrowIcon /> : <DownArrowIcon />}
          </span>
        </div>

        <div
          className={`${dropdowncss.dropdown_menu} ${
            open ? dropdowncss.open : ""
          }`}
           style={{
            marginTop: "6px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            borderRadius: "12px",
            background: "#fff",
            display: open ? "flex" : "none",
            flexDirection: "column",
            maxHeight: "250px",
            padding: "8px",
            boxSizing: "border-box",
            overflow: "hidden"
          }}
        >
          <div style={{ flex: 1, overflowY: "auto", maxHeight: "230px" }}>
            {filteredOptions.map((opt, i) => (
              <div
                key={i}
                className={dropdowncss.dropdown_item}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(opt);
                }}
              >
                {opt.label}
              </div>
            ))}
            {filteredOptions.length === 0 && (
              <div style={{ padding: "8px", color: "#888", textAlign: "center" }}>
                No options found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
